module.exports = __webpack_public_path__ + "img/h3.9a946ade.svg";